import React from "react";
import styled from "styled-components";

const FamilyBox = styled.div`
  position: absolute;
  right: 0;
  bottom: 30px;
  width: 172px;
`;
const FamilyLink = styled.a`
  display: block;
  padding: 10px;
  background: #292929;
  color: #fff;
  font-size: 12px;

  &:hover {
    background: #4a4a4a;
  }
`;

const Family = ({ langData }) => {
  const familyList = langData.footer.family;
  return (
    <FamilyBox>
      <ul>
        {familyList.map(list => (
          <li key={list.id}>
            <FamilyLink
              rel="noopener noreferrer"
              href={list.href}
              target="_blank"
              className="under"
            >
              {list.txt}
            </FamilyLink>
          </li>
        ))}
        {/* <li>
          <FamilyLink
            rel="noopener noreferrer"
            href="http://www.snu.ac.kr/index.html"
            target="_blank"
            className="under"
          >
            서울대학교
          </FamilyLink>
        </li>
        <li>
          <FamilyLink
            rel="noopener noreferrer"
            href="http://medicine.snu.ac.kr/"
            target="_blank"
            className="under"
          >
            서울대학교 의과대학
          </FamilyLink>
        </li>
        <li>
          <FamilyLink
            rel="noopener noreferrer"
            href="http://clinpharm.snu.ac.kr/"
            target="_blank"
            className="under"
          >
            서울대학교 대학원 협동과정·임상약리학 전공 페이지
          </FamilyLink>
        </li>
        <li>
          <FamilyLink
            rel="noopener noreferrer"
            href="http://www.snuh.org/intro.do"
            target="_blank"
            className="under"
          >
            서울대학교병원
          </FamilyLink>
        </li>
        <li>
          <FamilyLink
            rel="noopener noreferrer"
            href="http://ctc.snuh.org/"
            target="_blank"
            className="under"
          >
            서울대학교병원 의생명연구원
          </FamilyLink>
        </li>
        <li>
          <FamilyLink
            rel="noopener noreferrer"
            href="https://hrpp.snuh.org/pub/_/singlecont/view.do"
            target="_blank"
            className="under"
          >
            서울대학교병원 임상연구윤리센터(HRPP)
          </FamilyLink>
        </li> */}
      </ul>
    </FamilyBox>
  );
};

export default Family;
